import { cdnPath, injectScript } from "./Utils";

window.pbjs = window.pbjs || {};
window.pbjs.que = window.pbjs.que || [];

injectScript(cdnPath("/prebid.js"));

export default () => window.pbjs;
